import Component from '@glimmer/component'
import { service } from '@ember/service'
import type SchoolRolloverLockService from 'teacher-ui-client/services/school-rollover-lock'

/**
 * Locks a page during school rollover, visible when SchoolRolloverLockService.isCurrentRouteLocked === true
 */
export class RolloverLockOverlay extends Component {
  @service schoolRolloverLock!: SchoolRolloverLockService

  <template>
    {{#if this.schoolRolloverLock.isCurrentRouteLocked}}
      <div
        data-test-rollover-lock
        class="absolute inset-0 z-10 h-full w-full cursor-not-allowed bg-linear-to-b from-white/50 to-white"
      ></div>
    {{/if}}
  </template>
}

export default RolloverLockOverlay
